<template>
    <ModalDialogContainer
        ref="modalContainer"
        v-model:display="display"
        :static="isStatic"
        :lock-close="lockClose"
        :close-callback="closeCallback"
        :container-class="containerClass"
        @close="emit('close')"
        @key="emit('key', $event)"
    >
        <component :is="tag" class="modal-dialog" :class="`modal-${size}`" role="document" @click="stopPropagationEvent" @submit="onSubmit">
            <div class="modal-header">
                <div class="modal-title">
                    <slot name="title">{{ title }}</slot>
                </div>
                <button type="button" class="modal-close-btn" :title="t('Close')" @click="close()">
                    <i class="fas fa-times"></i>
                </button>
            </div>
            <div class="modal-body" :class="bodyClass">
                <slot :close="close"></slot>
            </div>
            <div v-if="$slots.footer" class="modal-footer">
                <div class="modal-footer-buttons">
                    <slot name="footer" :close="close"></slot>
                </div>
            </div>
        </component>
    </ModalDialogContainer>
</template>

<script setup lang="ts">
import { useTemplateRef } from "vue";
import { useModalDialog } from "@/composables/useModal";

defineOptions({ name: "UiModal" });

export type UiModalSize = "md" | "lg" | "lgb";

const display = defineModel<boolean>("display");

const {
    title = "",
    size = "md",
    static: isStatic = false,
    lockClose = false,
    closeCallback = undefined,
    tag = "div",
    bodyClass = "",
    containerClass = "",
} = defineProps<{
    title?: string;
    size?: UiModalSize;
    static?: boolean;
    lockClose?: boolean;
    closeCallback?: (done: () => void) => void;
    tag?: "div" | "form";
    bodyClass?: string;
    containerClass?: string;
}>();

const emit = defineEmits<{
    close: [];
    key: [e: KeyboardEvent];
    submit: [e: Event];
}>();

const modalContainer = useTemplateRef("modalContainer");
const { close, closeModal } = useModalDialog(display, modalContainer);

const stopPropagationEvent = (e: Event) => {
    e.stopPropagation();
};

const onSubmit = (e: Event) => {
    if (tag === "form") {
        emit("submit", e);
    }
};

defineExpose({ close: closeModal });
</script>
